import { HTTP } from '../../http-common'

export default {
  state: {
    loadedDeviceModels: []
  },
  getters: {
    loadedDeviceModels (state) {
      return state.loadedDeviceModels
    }
  },
  mutations: {
    setLoadedDeviceModels (state, payload) {
      state.loadedDeviceModels = payload
    },
    createDeviceModel (state, payload) {
      state.loadedDeviceModels.push(payload)
    },
    updateDeviceModel (state, payload) {
      state.loadedDeviceModels = state.loadedDeviceModels.map(deviceModel => deviceModel.id === payload.id ? payload : deviceModel)
    },
    removeDeviceModel (state, id) {
      state.loadedDeviceModels = state.loadedDeviceModels.filter(deviceModel => {
        return deviceModel.id !== id
      })
    },
    clearLoadedDeviceModels (state) {
      state.loadedDeviceModels = []
    }
  },
  actions: {
    loadDeviceModels ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedDeviceModels', [])

      return new Promise((resolve, reject) => {
        HTTP.get('device_model.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedDeviceModels', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createDeviceModel ({ commit, getters }, payload) {
      console.log('createDeviceModel')
      commit('clearError')
      commit('setLoading', true)
      const newDeviceModel = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('device_model.json/', newDeviceModel)
          .then(result => {
            console.log(result)
            commit('createDeviceModel', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateDeviceModel ({ commit, getters }, payload) {
      console.log('updateDeviceModel')
      commit('clearError')
      commit('setLoading', true)
      const deviceModel = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`device_model.json/${payload.id}/`, deviceModel)
          .then(result => {
            console.log(result)
            commit('updateDeviceModel', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeDeviceModel ({ commit }, payload) {
      console.log('removeDeviceModel')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`device_model.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeDeviceModel', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedDeviceModels ({ commit }) {
      commit('clearLoadedDeviceModels')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/device_model/index.js